'use strict';

import angular from 'angular';
const ngRoute = require('angular-route');

import routing from './account.routes';
import login from './login';
import settings from './settings';

export default angular.module('pizzutoAutopartesApp.account', [ngRoute, login, settings])
    .config(routing)
    .run(function ($rootScope) {
        'ngInject';

        $rootScope.$on('$routeChangeStart', function (event, next, current) {
            if (next.name === 'logout' && current && current.originalPath && !current.authenticate) {
                next.referrer = current.originalPath;
            }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/account/index.js